import { IWCCSliderAnimator } from "../animators/animator.interfaces";
import { WCCSliderBaseAnimatorConfig } from "../animators/base";
import { WCCSliderAnimatorType } from "../types/animatorType";

export const wccSliderAnimatorsFactoryKey = Symbol();


export interface ExtendedWCCSlideAnimatorConfig<T = any> extends WCCSliderBaseAnimatorConfig<T> {
    type: WCCSliderAnimatorType
}

export interface IWCCSliderAnimatorsFactory<T = any> {
    build(config: ExtendedWCCSlideAnimatorConfig<T>): IWCCSliderAnimator
}